import { Box, Typography } from '@mui/material'
import React from 'react'

const Technologies = () => {
  return (
    <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              maxWidth: "100%",
              height: "auto",
              alignItems: "center",
              padding: { xs: "5% 10%", sm: "5%" }, // Adjust padding for mobile and larger screens
            }}
          >
            <Typography
              sx={{
                display: "flex",
                alignContent: "center",
                justifyContent: "center",
                marginTop: "5%",
                fontFamily: "Orbitron !important",
                fontSize: { xs: "30px", sm: "50px" }, // Adjust font size for mobile
                fontWeight: "700",
                letterSpacing: "2%",
                lineHeight: "120%",
                textAlign: "center", // Ensures text is centered
              }}
            >
              Technologies
            </Typography>
    
            <img
              src="/assets/landingPage/modelImg.webp"
              loading="lazy"
              alt="tech"
              style={{
                width: "80%", // Image width adjusted for mobile view
                height: "auto",
                paddingTop: "3%",
                paddingBottom: "5%",
                maxWidth: "100%", // Ensures the image scales properly
              }}
            />
          </Box>
  )
}

export default Technologies